import React from 'react';
import { useLang } from '../context/LangContext';
import Sheet, { SheetBody } from '../lib/ui/Sheet';

const SUPPORT_PHONE = process.env.REACT_APP_SUPPORT_PHONE || '';
const SUPPORT_WHATSAPP = process.env.REACT_APP_SUPPORT_WHATSAPP || SUPPORT_PHONE;
const WA_DIGITS = SUPPORT_WHATSAPP.replace(/\D/g, '');
const CALL_NUMBER = SUPPORT_PHONE;

export default function SupportSheet({ open, onClose }) {
  const { lang } = useLang();
  const te = lang === 'te';
  const L = (en, t) => (te ? t : en);

  const waMsg = encodeURIComponent(te ? 'నమస్కారం, నాకు సహాయం కావాలి.' : 'Hi, I need help with my order.');

  const guard = (configured) => (e) => {
    if (!configured) {
      e.preventDefault();
      window.alert(L('Not configured. Please try the other option.', 'సెట్ కాలేదు. దయచేసి మరో ఎంపిక వాడండి.'));
      return;
    }
    onClose();
  };

  return (
    <Sheet open={open} onClose={onClose} maxWidth={420} labelledBy="support-title">
      <SheetBody className="pt-6 text-center">
        <div id="support-title" className="text-xl font-black text-brand-dark mb-1">
          🆘 {L('Customer Support', 'కస్టమర్ సపోర్ట్')}
        </div>
        <div className="text-sm text-ink-faint mb-6">{L('How would you like to reach us?', 'మీరు ఎలా సంప్రదించాలనుకుంటున్నారు?')}</div>

        <div className="flex flex-col gap-3 mb-5 text-left">
          <a
            href={WA_DIGITS ? `https://wa.me/${WA_DIGITS}?text=${waMsg}` : '#'}
            target="_blank"
            rel="noreferrer"
            onClick={guard(!!WA_DIGITS)}
            className="flex items-center gap-3.5 px-4 py-4 rounded-2xl text-white shadow-card bg-gradient-to-br from-emerald-600 to-emerald-500"
          >
            <span className="text-2xl">💬</span>
            <div className="flex-1">
              <div className="font-black">{L('WhatsApp Chat', 'WhatsApp చాట్')}</div>
              <div className="text-xs opacity-85 mt-0.5">{WA_DIGITS ? `+${WA_DIGITS}` : L('Message us', 'మెసేజ్ చేయండి')}</div>
            </div>
            <span className="opacity-80">→</span>
          </a>
          <a
            href={CALL_NUMBER ? `tel:${CALL_NUMBER}` : '#'}
            onClick={guard(!!CALL_NUMBER)}
            className="flex items-center gap-3.5 px-4 py-4 rounded-2xl text-white shadow-card bg-gradient-to-br from-sky-700 to-sky-500"
          >
            <span className="text-2xl">📞</span>
            <div className="flex-1">
              <div className="font-black">{L('Call Us', 'కాల్ చేయండి')}</div>
              <div className="text-xs opacity-85 mt-0.5">{CALL_NUMBER || L('See website', 'వెబ్‌సైట్ చూడండి')}</div>
            </div>
            <span className="opacity-80">→</span>
          </a>
        </div>

        <div className="text-xs text-ink-faint mb-4">🕐 {L('Available 9 AM – 7 PM, 7 days a week', 'అందుబాటులో ఉ. 9 – సా. 7')}</div>

        <button type="button" onClick={onClose} className="w-full py-3 rounded-xl bg-black/5 text-ink-soft font-extrabold text-sm">
          {L('Cancel', 'రద్దు')}
        </button>
      </SheetBody>
    </Sheet>
  );
}
